import {createSelector} from "reselect";

const address = (state) => state.address;

const getAddressListData = createSelector(
  address,
  (address) => address.addressListData || {}
);

export const getAddressList = createSelector(getAddressListData, (addressData) => {
  if (addressData?.results?.length > 0) {
    return addressData.results.map((eachAddress) => ({
      ...eachAddress,
      address: eachAddress.street_address1,
    }));
  } else {
    return [];
  }
});

export const getTotalCount = createSelector(
  getAddressListData,
  (addressData) => addressData?.total_count
);

export const getPaginationUrls = createSelector(getAddressListData, (addressData) => ({
  prevUrl: addressData.previous,
  nextUrl: addressData.next,
}));
